
/**
 * Объект-конфигурация компонентов текстового поля ввода по типам
 */
const types = {
  city: 'CoreInputSelectTypesCity',
  stream: 'CoreInputSelectTypesStream',
  account: 'CoreInputSelectTypesAccount',
  product: 'CoreInputSelectTypesProduct',
  'account-type': 'CoreInputSelectTypesAccountType',
  'provision-type': 'CoreInputSelectTypesAdvertisementProvisionType',
  'work-place': 'CoreInputSelectTypesAdvertisementPlaceOfWork',
  'cost-type': 'CoreInputSelectTypesCostType',
  'vacancy-cost-type': 'CoreInputSelectTypesVacancyCostType',
  'vacancy-employment': 'CoreInputSelectTypesVacancyEmployment',
  'cost-for-type': 'CoreInputSelectTypesCostForType',
  'stream-url': 'CoreInputSelectTypesStreamUrl',
  'date-range': 'CoreInputSelectTypesDateRange',
  icons: 'CoreInputSelectTypesIcons',
  format: 'CoreInputSelectTypesFormat',
  default: 'CoreInputSelectTypesDefault',
}
export default {
  name: 'CoreInputSelect',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Двунаправленная привязка текста введённого в поле
     */
    value: {
      type: [Object, String, Number, Boolean],
      default: null,
    },

    /**
     * Флаг устанавливает обязательность заполнения поля
     */
    required: {
      type: Boolean,
      default: false,
    },

    /**
     * Тип поля ввода.
     */
    type: {
      type: String,
      default: 'default',

      validator: (value) => {
        return Object.keys(types).includes(value)
      },
    },
  },

  computed: {
    inputForType() {
      return this.getType(this.type)
    },
  },
  methods: {
    getType: (type) => types[type] || types.default,
  },
}
